import { render, staticRenderFns } from "./VText.vue?vue&type=template&id=7d3a7246&scoped=true&"
import script from "./VText.vue?vue&type=script&lang=js&"
export * from "./VText.vue?vue&type=script&lang=js&"
import style0 from "./VText.vue?vue&type=style&index=0&id=7d3a7246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3a7246",
  null
  
)

export default component.exports